/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pph.vue?vue&type=template&id=3b5e8d0d&scoped=true"
import script from "./pph.vue?vue&type=script&lang=js"
export * from "./pph.vue?vue&type=script&lang=js"
import style0 from "./pph.vue?vue&type=style&index=0&id=3b5e8d0d&prod&lang=scss"
import style1 from "./pph.vue?vue&type=style&index=1&id=3b5e8d0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5e8d0d",
  null
  
)

export default component.exports